import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-view-driver',
  templateUrl: './view-driver.component.html',
  styleUrls: ['./view-driver.component.scss']
})
export class ViewDriverComponent implements OnInit {
editdata:any;
Drivername:any;
Phoneno:any;
email:any;
VehicleType:any
vehicleNo:any;
vehicleName:any;
licence:any;
licenceValidity:any
Rcvalidity:any;
driverimage:any;
driverrc:any;
driverlicence:any;
driverid:any;
driveraddressproof:any
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,public dialog: MatDialog,private dialogRef: MatDialogRef<ViewDriverComponent>) { }

  ngOnInit(): void {
    this.editdata=this.data;
    this.Drivername=this.data.name;
    this.Phoneno=this.data.phoneNo
    this.email=this.data.email
this.VehicleType=this.data.vehicleType;
this.vehicleNo=this.data.vehicleNo;
this.vehicleName=this.data.vehicleName;
this.licence=this.data.licenceNo
this.licenceValidity=this.data.licenceValidity

this.Rcvalidity=this.data.rcValidity
this.driverimage=this.data.driverImage
this.driverrc=this.data.uploadedDocument.rc

this.driverlicence=this.data.uploadedDocument.licence
this.driverid=this.data.uploadedDocument.idProof
this.driveraddressproof=this.data.uploadedDocument.addressProof


  }
  closeDialog() {
    this.dialogRef.close();
  }
}
